import React, { Fragment } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link, NavLink } from 'react-router-dom';
import LoginLink from 'src/components/LoginLink';
import { hideDropDown } from 'src/util/UIUtil';

const PrimaryNav = (props: React.HTMLAttributes<HTMLElement>) => {
  const  { isAuthenticated } = useAuth0()
  if (!isAuthenticated) {
    return <Fragment />
  }

  return (
    <Fragment>
      <nav className="uk-navbar-container uk-flex-column uk-flex-top uk-padding-none" data-uk-navbar data-uk-toggle="media: @s; cls: uk-flex-row uk-flex-top; mode: media">
        {
          // @ts-ignore -->
          <button type="button" data-uk-toggle="target: .navbar-collapse; cls: hidden-up-to-s uk-padding-remove"
            className="uk-navbar-toggle uk-hidden@s" data-uk-navbar-toggle-icon></button>
        }
        <div className="navbar-collapse hidden-up-to-s">
          <div className="uk-navbar-left" >
            {
              <ul data-uk-toggle="media: @s; cls: uk-navbar-nav uk-padding-remove; mode: media" className="uk-nav uk-nav-primary uk-padding-small">
                  <li className={'uk-parent' + (window.location.pathname === '/salesorders' && ' uk-active')}>
                    <NavLink to="/salesorders" className={({ isActive }) => isActive ? "uk-active": undefined}>Salesorders</NavLink>
                  </li>
                  <li className={'uk-parent' + (window.location.pathname === '/warranties' && ' uk-active')}>
                    <NavLink to="/warranties" className={({ isActive }) => isActive ? "uk-active": undefined}>Warranties</NavLink>
                  </li>
                  <li className={'uk-parent' + (window.location.pathname.match(/\/Admin/) && ' uk-active')}>
                    <a href="#">Admin <span uk-icon="triangle-down"></span></a>
                    <div id="adminDropdown" uk-dropdown="pos: bottom-left; duration: 10; mode: click"
                      className="uk-margin-remove-top uk-padding-remove-top uk-navbar-dropdown">
                      <ul className="uk-nav">
                        <li onClick={() => hideDropDown('adminDropdown')}>
                          <NavLink to="/Admin_LoginHistory" className={({ isActive }) => isActive ? "uk-active": undefined}>Login History</NavLink>
                        </li>
                        <li onClick={() => hideDropDown('adminDropdown')}>
                          <NavLink to="/Admin_LoadOperations" className={({ isActive }) => isActive ? "uk-active": undefined}>Load Operations</NavLink>
                        </li>
                        <li onClick={() => hideDropDown('adminDropdown')}>
                          <NavLink to="/Admin_TaskList" className={({ isActive }) => isActive ? "uk-active": undefined}>Tasks</NavLink>
                        </li>
                      </ul>
                    </div>
                  </li>
              </ul>
            }
          </div>
        </div>
      </nav>

    </Fragment >
  );
};

export default PrimaryNav;
